import { track } from '../track'
import { EXPERIMENT_VIEWED } from '~/lib/tracking-events'

export function callback(variationId, experimentId) {
  // Do not track control group
  if (variationId === '0') return false

  track(EXPERIMENT_VIEWED, {
    experimentId: experimentId,
    variationId: variationId,
  })
}

// Mandatory for the callback to work, we need the Arguments type
export function gtag() {
  global.dataLayer.push(arguments)
}

export function trackExperiments(firstLoad) {
  global.dataLayer = global.dataLayer || []

  if (!firstLoad) {
    // Custom activation event for Google Optimize
    return global.dataLayer.push({ event: 'optimize.activate' })
  }

  global.dataLayer.push({ event: 'optimize.activate' })
  gtag('event', 'optimize.callback', { callback })
}
